export default __webpack_public_path__ + "static/442-c19b6c1b28b46b11f7a69f98fa118738.gif";